import React from 'react';
import sprites from '../../img/sprites.svg';
import { courseHint } from './constants';
import { HeadphonesIcon } from '../../common/VocabularyButton/VocabularyButton';
import './course-hint.scss';

const CourseTooltipHint = () => {
  return (
    <div className='course-hint'>
      {courseHint.map((item, idx) => (
      <div className='course-hint__block' key={idx}>
        <div className='course-hint__icon'>
          {/* Навушників у спрайті немає — та сама інлайн-іконка, що й на кнопці */}
          {item.icon === 'headphones'
            ? <HeadphonesIcon className={`icon icon--${item.iconColor} icon--md`} />
            : <svg className={`icon icon--${item.iconColor} icon--md`}><use xlinkHref={`${sprites}#${item.icon}`}></use></svg>}
        </div>
        <div className="course-hint__text">
          <span>-</span>
          {item.text}
        </div>
      </div>
      ))}
    </div>
  );
};

export default CourseTooltipHint;